// @ts-nocheck
import * as React from "react";

const CheckboxChecked: React.FC = () => {
    return (
        <svg focusable="false" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                fill="currentColor"
                d="M16.758 5.653a1.724 1.724 0 012.601 2.255l-7.834 10.286c-.324.42-.824.667-1.354.669l-.224-.013a1.712 1.712 0 01-1.13-.638L4.65 12.879l-.122-.178a1.716 1.716 0 012.831-1.93l2.794 3.617 6.48-8.571h-.017l.142-.164z"
            />
        </svg>
    );
};

export default React.memo(CheckboxChecked);
